import client from '../request'

const getAll = `/videos`

const get = (id) => {
  return `/videos/${id}`
}

const getByClient = (id) => {
  return client.get(`/videos/${id}`)
}

const create = (data) => {
  return client.post('/videos', data)
}

const update = (id, data) => {
  return client.put(`/videos/${id}`, data)
}

const toRow = (data) => {
  if (data?.data?.length > 0) {
    return data?.data.map((element) => {
      return {
        ...element,
        key: element.id
      }
    })
  }

  return []
}

const toPaginate = (data) => {
  return {
    total: data?.meta?.total ?? 0
  }
}
const remove = (id) => {
  return client.delete(`/videos/${id}`)
}

const VideoService = {
  getAll,
  get,
  getByClient,
  create,
  update,
  toRow,
  toPaginate,
  remove
}

export default VideoService
